import React from "react";
import { Box, SpaceBetween } from "@amzn/awsui-components-react";

import { CatalogIssuesSummary as CatalogIssuesSummaryData } from "../../../from-server/asin-central/catalog-issues";

export interface CatalogIssuesSummaryProps {
  /** Number of ASIN rows currently listed in the table (after filtering). */
  readonly listedAsinCount: number;
  readonly summary: CatalogIssuesSummaryData;
}

/**
 * `Catalog Issues (N)` heading plus the secondary-colour summary line
 * (`N ASINs, N errors, N warnings`) shown directly beneath it.
 */
export const CatalogIssuesSummary: React.FC<CatalogIssuesSummaryProps> = ({
  listedAsinCount,
  summary,
}) => {
  return (
    <SpaceBetween size="xxs">
      <Box variant="h2" data-testid="catalog-issues-heading">
        Catalog Issues ({listedAsinCount})
      </Box>
      <Box
        variant="p"
        color="text-body-secondary"
        data-testid="catalog-issues-summary-line"
      >
        {summary.totalAsins} ASINs, {summary.errors} errors, {summary.warnings}{" "}
        warnings
      </Box>
    </SpaceBetween>
  );
};

export default CatalogIssuesSummary;
